/**
 * Remove `undefined` properties of an object.
 * @param obj The object to use.
 * @returns A copy of the object without the `undefined` properties.
 */
export function removeUndefinedProps<T extends Record<keyof any, any>>(
  obj: T
): T {
  const copy = { ...obj };
  for (const key of Object.keys(copy)) {
    if (copy[key] === undefined) {
      delete copy[key];
    }
  }
  return copy;
}
